module.exports = ".fa.fa-trash {\n  cursor: pointer;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/user/_validation/validation.component.scss
// module id = ./src/app/user/_validation/validation.component.scss
// module chunks = main